/* global initGeetest:false */
import * as aTypes from '../action-types'
import * as mTypes from '../mutation-types'
import api from '../../api'

export let captchaObj = null

const state = {
  captchaObjInited: false,
  validate: null
}

const actions = {
  [aTypes.GEETEST_INIT] ({ state, commit }, payload) {
    api.login.getRobotCaptcha({
      success (res) {
        const data = res.body
        if (data) {
          initGeetest({
            'gt': data.gt,
            'challenge': data.challenge,
            'offline': !data.success,
            'new_captcha': data.new_captcha,
            'width': '100%'
          }, function (co) {
            captchaObj = co
            commit(mTypes.GEETEST_SET_CAPTCHA_OBJ_INITED, true)
          })
        }
      },
      commit
    })
  },
  [aTypes.GEETEST_DESTORY] ({ commit }) {
    commit(mTypes.GEETEST_SET_CAPTCHA_OBJ_INITED, false)
    commit(mTypes.GEETEST_SET_VALIDATE, null)
    captchaObj = null
  }
}

const mutations = {
  [mTypes.GEETEST_SET_CAPTCHA_OBJ_INITED] (state, captchaObjInited) {
    state.captchaObjInited = captchaObjInited
  },
  [mTypes.GEETEST_SET_VALIDATE] (state, validate) {
    state.validate = validate
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/geetest.js